<template>
  <div class="document-container">
    <div class="columns">
      <div class="column column-left is-three-quarters is-paddingless">
        <div class="flex-container-left">
          <div>
              <div class="document-container">
                <div class="document">
                  <div class="header">
                    <es-header>
                      <template #header>
                        <div class="header-title">Customize Report: FNS-834</div>
                      </template>
                    </es-header>
                  </div>
                  <div class="content">
                    <es-form>
                      <template #es-form-header>
                        <div class="header-container">
                          <div class="header-elements">
                            <font-awesome-icon :icon="['fas', 'users-class']" size="lg" />
                          </div>
                          <div class="header-elements">
                            <h6 class="title">
                              School-Aged Children
                            </h6>
                          </div>
                        </div>
                      </template>
                      <template #es-form>
                        <div class="field is-horizontal">
                        </div>
                        <div class="field is-horizontal">
                          <div class="field-label">
                            <label class="label">Data Element #2</label>
                          </div>
                          <div class="field-body">
                            <div class="field is-narrow">
                              <div class="control">
                                <input class="input" :class="{ 'is-danger': hasErrorNumber }" v-model="snapHouseholdKidsCount" type="text">
                              </div>
                              <span v-if="hasErrorNumber" class="help is-danger">
                                {{ snapHouseholdKidsCountMsg }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="header-container">
                          <div class="header-elements">
                            <font-awesome-icon :icon="['fas', 'bell']" size="lg" />
                          </div>
                          <div class="header-elements">
                            <h6 class="title">
                              Special Circumstances
                            </h6>
                          </div>
                        </div>
                        <div class="field is-horizontal">
                        </div>
                        <div class="field is-horizontal">
                          <div class="field-label">
                            <label class="label">Special Circumstances Alert<br>
                              <small class="text-muted">(optional)</small>
                            </label>
                          </div>
                          <div class="field-body">
                            <div class="field is-narrow">
                              <div class="control">
                                <label class="checkbox">
                                  <input type="checkbox" v-model="specialCircumstances"
                                  value="1"
                                  name="specialCircumstances">
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </es-form>
                  </div>
                  <div class="es-actions">
                    <es-form-actions>
                      <template #form-actions>
                        <div class="bottom-content">
                          <ul>
                            <li class="reset">
                              <div class="list-content">
                                <a @click="$router.push('/directMatch/reports')">
                                  Cancel
                                </a>
                              </div>
                            </li>
                            <li>
                              <div class="list-content">
                                <button
                                  class="button is-primary"
                                   @click="post"
                                  >
                                    Generate
                                </button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </template>
                    </es-form-actions>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="column column-right is-one-quarter is-paddingless">
        <div class="flex-container-right">
          <div class="document-container">
            <div class="document" name="instructions">
              <div class="header">
                <es-header>
                  <template #header>
                    <div class="header-title">Instructions</div>
                  </template>
                </es-header>
              </div>
              <div class="activity-row">
                <div class="activity-row-container">
                  <div class="activity-summary">
                    <div class="activity-status activity-element">
                      <div>
                        <span class="has-text-weight-bold">
                          School Aged Children
                        </span>
                      </div>
                      <div>
                        <span class="has-text-grey">
                          Please enter, in the box provided for Data Element #2,
                          the unduplicated count of the number of children
                          ages 5 to 17 years at any time during the months of
                          July, August, or September of this school year who were
                          members of households receiving assistance under SNAP
                          at any time during the months of
                          July, August, or September of this school year.
                        </span>
                      </div>
                      <div>
                        <span class="has-text-weight-bold">
                          Special Circumstances
                        </span>
                      </div>
                      <div>
                        <span class="has-text-grey">
                          If there are special circumstances that would affect
                          the direct certification rate calculation for your
                          State that you would like to bring to FNS attention,
                          please let FNS know by marking an "X" in the box to the
                          right of Special Circumstances Alert.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import moment from 'moment';

import 'vue-popperjs/dist/vue-popper.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faTimes,
  faCheckCircle,
  faBell,
  faEdit,
  faEllipsisH,
  faFileCsv,
  faFileEdit,
  faFilter,
  faMapMarkerAlt,
  faNotEqual,
  faSchool,
  faUser,
  faUserCircle,
  faUsersClass,
  faUserFriends,
  faUsersCog,
} from '@fortawesome/pro-light-svg-icons';
import {
  faBell as faBellSolid,
  faFileCsv as faFileCsvSolid,
  faFileEdit as faFileEditSolid,
  faFilter as faFilterSolid,
  faSchool as faSchoolSolid,
  faUser as faUserSolid,
  faUserCircle as faUserCircleSolid,
  faUsersClass as faUsersClassSolid,
  faUserFriends as faUserFriendsSolid,
  faUsersCog as faUsersCogSolid,
} from '@fortawesome/pro-solid-svg-icons';
import Popper from 'vue-popperjs';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';

import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

var ws;

library.add(
  faAngleRight,
  faTimes,
  faCheckCircle,
  faBell,
  faBellSolid,
  faEdit,
  faEllipsisH,
  faFileCsv,
  faFileCsvSolid,
  faFileEdit,
  faFileEditSolid,
  faFilter,
  faFilterSolid,
  faMapMarkerAlt,
  faNotEqual,
  faSchool,
  faSchoolSolid,
  faUser,
  faUserCircle,
  faUsersClass,
  faUserFriends,
  faUsersCog,
  faUserSolid,
  faUserCircleSolid,
  faUsersClassSolid,
  faUserFriendsSolid,
  faUsersCogSolid,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  created() {
    this.setBreadcrumbs();
  },
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
    EsLoader,
    Popper,
  },
  data() {
    return {
      messages: [],
      reportType: 'FNS834',
      snapHouseholdKidsCount: '',
      specialCircumstances: '',
      hasErrorNumber: false,
      snapHouseholdKidsCountMsg: '',
      formErrorMsg: 'There were some errors. Please try again. If errors persist please contact support.',
    };
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
  },
  methods: {
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'directMatch' } },
        { text: 'Reports', to: { name: 'reportsmaind' } },
        { text: 'FNS-834 Report', to: {} },
      ]);
    },
    resetForm() {
      this.snapHouseholdKidsCount = '';
      this.specialCircumstances = '';
      this.hasErrorNumber = false;
      this.snapHouseholdKidsCountMsg = '';
    },
    resetErrors() {
      this.hasErrorNumber = false;
      this.snapHouseholdKidsCountMsg = '';
    },
    async post() {
      // Local Code || State Location Id
      if(this.checkNumber()) {
        try {
          const res = await axios.post('/reports/', ({
            reportType: this.reportType,
            snapHouseholdKidsCount: this.snapHouseholdKidsCount,
            specialCircumstances: this.specialCircumstances,
          }));
          this.$emit('reportCreated', res.data);
          this.$router.push('/directMatch/reports');
        } catch (err) {
          this.showNotification('danger', [this.formErrorMsg]);
        }
      } else {
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      }
    },
    checkNumber() {
      this.resetErrors();
      if (this.snapHouseholdKidsCount.length > 0 && !isNaN(this.snapHouseholdKidsCount)) {
        return true;
      } else {
        if(isNaN(this.snapHouseholdKidsCount)) {
          this.snapHouseholdKidsCountMsg = 'Data Element #2 should be numeric.';
        } else {
          this.snapHouseholdKidsCountMsg = 'Data Element #2 is required.';
        }
        this.hasErrorNumber = true;
        return false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .text-muted
    color: #6c757d !important
  .activity-row
    border-top: 1px solid rgb(222, 226, 230)
  .activity-row-container
    padding: .5rem 1rem
    display: flex
  .icon-column
    min-width: 40px
    display: flex
    align-items: flex-start
  .activity-summary
    font-size: .85rem
    display: flex
    flex-direction: column
    align-items: flex-start
  .activity-element
    padding-top: 4px
    padding-bottom: 4px
    text-align: left
  .activity-status
    text-align: left
</style>
